import { Stack } from "@mui/material";
import { useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';

import logo from '../resources/ember_logo_3d.png';

import WhatshotIcon from '@mui/icons-material/Whatshot';
import WhatshotOutlinedIcon from '@mui/icons-material/WhatshotOutlined';
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';


function SideBarButton(props) {
    const [hover, setHover] = useState(false);

    return (
        <Stack direction={'row'} spacing={3}>
            <a 
                className="app-font"
                href={props.link}
                onClick={props.onClick}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                style={{
                    color: '#3f0300',
                    textDecoration: 'none',
                    fontSize: '17px',
                    fontWeight: '700',
                    padding: '16px',
                    borderRadius: '5px',
                    width: '100%',
                    textAlign: 'left',
                    display: 'block',
                    background: hover ? 'white' : 'transparent',
                    border: props.active ? '1px solid #3f0300' : '',
                }}
            >
                <Stack 
                    direction="row" 
                    spacing={2}
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                >
                    <div>{props.icon}</div>
                    <div style={{marginTop:'-2px'}}>{props.text}</div>
                    {/* 
                    */}
                </Stack>
            </a>
        </Stack>
    )
}

function SideBar(props) {
    const { logout } = useAuth0();
    return (
        <Stack 
            direction={'column'} 
            spacing={1}
            style={{
                // paddingTop: '5px',
                // padding: '2px',
                paddingLeft: '20px',
            }}
        >
            <Stack
                direction={'row'} 
                spacing={2}
                justifyContent={'flex-start'}
                alignItems={'center'}
                style={{ paddingBottom: '16px' }}
            >
                {/* <img src={logo} alt="Ember Logo" style={{ paddingLeft: '6px', paddingTop: '30px', paddingBottom: '16px', width: '40px' }} />  */}
                <span

                    className="app-font-fancy"
                    style={{
                        color: '#3f0300',
                        fontSize: '2.2rem',
                        fontWeight: '700',
                        marginTop: '15px',
                        marginLeft: '5px',

                        paddingLeft: '15px',
                        paddingTop: '20px',
                    }}
                >
                    Ember
                </span>
            </Stack>
            <SideBarButton link='/' text='Embers' icon={<WhatshotIcon/>} />
            {/* <SideBarButton link='/jobapp' text='Apply For Me' icon={<AssignmentOutlinedIcon />}/> */}
            {/* <SideBarButton link='/u' text='Profile' icon={<AccountCircleOutlinedIcon />} /> */}
            <SideBarButton 
                link="javaScript:void(0)"
                onClick={() =>
                    logout({ 
                        logoutParams: {
                            returnTo: window.location.origin 
                        }
                    })
                }
                text='Logout'
                icon={<LogoutOutlinedIcon />}
            />
        </Stack>
    )
}

export { SideBar };